import { UserInfoResponse } from '@/types/userInfo/UserInfoResponseType'
import { Translator } from '@/types/ApiResponseTypes'

class UserInfoResponseTranslator implements Translator<UserInfoResponse> {
  convert(input: UserInfoResponse): UserInfoResponse {
    return input
  }
}

export default new UserInfoResponseTranslator()
